import React from "react";
import BottomSheet from "../BottomSheet";
import { Phone } from "lucide-react";
import Button from "../Button";
import { EVENT_NAMES, SCREEN_NAMES } from "src/helpers/analytics/events";
import analytics from "src/helpers/analytics";
import supportPrograms from "src/data/app/programs";
import { POST_MESSAGE_EVENTS } from "src/constants/common";
import { sendMessageToParent } from "src/helpers/common";
import { toast } from "sonner";

interface CallCounselorBottomSheetProps {
  setShowBottomSheet: (show: boolean) => void;
  supportProgramKey: string;
  title: string;
  number: string;
}

const CallCounselorBottomSheet: React.FC<CallCounselorBottomSheetProps> =
  React.memo(
    ({
      setShowBottomSheet,
      supportProgramKey,
      title,
      number,
    }: CallCounselorBottomSheetProps) => {
      const config =
        supportPrograms[supportProgramKey as keyof typeof supportPrograms];
      const telecounselorNumber = config?.app?.screens?.[
        "home-screen"
      ]?.components
        ?.find((card) => card?.id === "services-card")
        ?.services?.find((comp) => comp?.id === "call-telecounselor")?.number;

      const handleCallTelecounselor = () => {
        // Event: CALL_TELECOUNSELOR_CLICKED
        analytics.trackEvent(EVENT_NAMES.CALL_TELECOUNSELOR_CLICKED, {
          screen_name: SCREEN_NAMES.HOME_SCREEN,
          support_program_key: supportProgramKey,
          card_title: title,
          number: number,
        });

        const payload = {
          type: "CALL_PHONE",
          number: telecounselorNumber,
        };

        if (payload.number) {
          sendMessageToParent(POST_MESSAGE_EVENTS.CALL_PHONE, payload);
        } else {
          toast.error("Teleconseler number is not valid, please check.");
        }
      };

      const formatPhoneNumber = (phone: string) => {
        return `${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(
          6,
          9
        )} ${phone.slice(9)}`;
      };

      return (
        <BottomSheet
          show={true}
          handleClose={() => setShowBottomSheet(false)}
          showCloseButton={true}
        >
          <div className="p-6 space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900">
                Telecounselor
              </h3>
            </div>

            <div className="py-4 text-center">
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
                <Phone className="w-8 h-8 text-green-600" />
              </div>
              <p className="text-2xl font-semibold text-gray-900 mb-2">
                {telecounselorNumber
                  ? formatPhoneNumber(telecounselorNumber)
                  : "Number is Unavailable"}
              </p>
              <p className="text-sm text-gray-500">
                Available Mon-Sat, 9 AM - 6 PM
              </p>
            </div>

            <div className="space-y-2 pt-2">
              <Button
                size="lg"
                rounded="full"
                onClick={handleCallTelecounselor}
                fullWidth
              >
                Call Now
              </Button>

              <Button
                size="lg"
                rounded="full"
                onClick={() => setShowBottomSheet(false)}
                variant="outlined"
                fullWidth
              >
                Cancel
              </Button>
            </div>
          </div>
        </BottomSheet>
      );
    }
  );

export default CallCounselorBottomSheet;
